import { useContext } from 'react';
import { ActiveChatSessionContext } from '@trinity/chat-components/components/Chat/context.js';
import { MessageGenerationStateContext } from './Context';

/**
 * Returns `true` once the active chat session matches the message-generation
 * session's chat instance, indicating the chat interface is wired up and ready.
 */
export function useMessageGenChatReady(): boolean {
  const messageGenSession = useContext(MessageGenerationStateContext);
  const activeChatSession = useContext(ActiveChatSessionContext);

  return (
    !!messageGenSession?.chatInstanceIdentifier &&
    activeChatSession?.identifier === messageGenSession.chatInstanceIdentifier
  );
}
